import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import loadingGif from '../../images/loading.gif';
import { RootState } from '../../store';
import { CX_2019 } from '../../models/constants';
import { IOBOAccount, ISelectedOboAccount } from '../../models/obo-account';
import { ISession } from '../../models/pro-sites';
import { IResult } from '../../models/result-models';
import { searchOBOAccount } from '../../store/obo/obo-actions';
import { updateLoadSession } from '../../store/session/session-actions';
import { hasFeature } from '../authorization/features';
import AccountSelector from './account-selector';
import { WrappedComponentProps, injectIntl, useIntl } from 'react-intl';
interface IOBOProps {
    searchOBOAccount: (accountNumber: string) => Promise<IResult<IOBOAccount>>;
    session: ISession | null;
    updateLoadSession: (session: ISession) => Promise<boolean>;
    selectedOboAccount: ISelectedOboAccount | null;
}

export const AccountSearch: React.FC<IOBOProps> = ({
    searchOBOAccount,
    session,
    updateLoadSession,
    selectedOboAccount,
}) => {
    const intl = useIntl();
    const [OBOState, setOBOState] = useState<IOBOAccount | null>();
    const [accountNumber, setAccountNumber] = useState<string>('');
    const [oboSelection, setOboSelection] =
        useState<ISelectedOboAccount | null>({
            ...selectedOboAccount!,
        });
    const [sessionState, setSessionState] = useState<ISession>({ ...session! });
    const [searching, setSearching] = useState(false);
    const [errors, setErrors] = useState({ noAccounts: false });

    const handleNoAccounts = () => {
        setErrors({ noAccounts: true });
        setAccountNumber('');
        setSearching(false);
    };

    const searchAccount = async (event: any) => {
        try {
            event.preventDefault();
            setSearching(true);
            const result = await searchOBOAccount(accountNumber);
            if (result) {
                setSearching(false);
                if (
                    result.data!.billToAccounts.length === 0 ||
                    result.data!.shipToAccounts.length === 0
                ) {
                    handleNoAccounts();
                    return;
                }
                setOboSelection({
                    accountNumber: accountNumber,
                    billToAccount:
                        result.data!.billToAccounts[0].accountNumber.split(
                            ' -'
                        )[0],
                    shipToAccount:
                        result.data!.shipToAccounts[0].accountNumber.split(
                            ' -'
                        )[0],
                });
                setOBOState(result.data!);
            }
        } catch {
            handleNoAccounts();
            return;
        }
    };

    const updateSession = async (event: any) => {
        event.preventDefault();
        setSearching(true);
        const result = await updateLoadSession(sessionState);
        if (result) {
            if (hasFeature(session!, CX_2019)) {
                window.location.href = '/prosite/estore';
            } else {
                window.location.href = '/estore';
            }
        }
    };

    const handleChange = (e: any) => {
        setAccountNumber(e.target.value.toUpperCase());
        setErrors({ noAccounts: false });
    };

    const handleCancel = () => {
        setOBOState(null);
        setAccountNumber('');
        setSearching(false);
    };

    const handleBillToSelection = (e: any) => {
        setOboSelection({ ...oboSelection!, billToAccount: e.target.value });
    };

    const handleShipToSelection = (e: any) => {
        setOboSelection({ ...oboSelection!, shipToAccount: e.target.value });
    };

    useEffect(() => {
        setSessionState({ ...session!, selectedOboAccount: oboSelection! });
    }, [oboSelection]);

    return (
        <div className="container" style={{ height: '100%' }}>
            <div
                className="col-md-12 text-center"
                style={{ marginTop: '20px' }}
            >
                <div className="row">
                    <h1>
                        {intl.formatMessage({
                            id: 'Welcome_to_the_Staff_Prosite',
                            defaultMessage: 'Welcome to the Staff Prosite',
                        })}
                    </h1>
                </div>
                <div className="col-md-3" />
                <form onSubmit={searchAccount}>
                    <div className="input-group col-md-6">
                        <span className="input-group-addon" id="SearchLabel">
                            {' '}
                            <strong>
                                {intl.formatMessage({
                                    id: 'Search_for_an_Account',
                                    defaultMessage: 'Search for an Account',
                                })}
                                :
                            </strong>{' '}
                        </span>
                        <input
                            disabled={OBOState ? true : false}
                            type="text"
                            value={accountNumber}
                            className="form-control"
                            onChange={handleChange}
                            aria-describedby="SearchLabel"
                        />
                    </div>
                    <div className="col-md-3" />
                    <div className="col-md-12">
                        <div>
                            <h4>
                                {' '}
                                {intl.formatMessage({
                                    id: 'Miracle-Ear_orders_are_not_supported',
                                    defaultMessage:
                                        'Miracle-Ear orders are not supported',
                                })}
                            </h4>
                        </div>
                    </div>
                    <br />

                    {!OBOState ? (
                        <div className="row">
                            {!searching ? (
                                <button
                                    disabled={!accountNumber}
                                    type="submit"
                                    className="btn btn-primary"
                                >
                                    {intl.formatMessage({
                                        id: 'Search',
                                        defaultMessage: 'Search',
                                    })}
                                </button>
                            ) : (
                                <button
                                    disabled={true}
                                    className="btn btn-primary"
                                >
                                    <img src={loadingGif} alt="searching" />
                                    {intl.formatMessage({
                                        id: 'Searching',
                                        defaultMessage: 'Searching',
                                    })}
                                    ...
                                </button>
                            )}
                        </div>
                    ) : (
                        <div />
                    )}
                    {errors.noAccounts ? (
                        <div className="row">
                            <label className="alert alert-danger">
                                {intl.formatMessage({
                                    id: 'No_accounts_found',
                                    defaultMessage: 'No accounts found',
                                })}
                            </label>
                        </div>
                    ) : (
                        <div />
                    )}
                </form>
                {OBOState ? (
                    <div
                        className="well"
                        style={{ height: 'auto', padding: '2%' }}
                    >
                        <form onSubmit={updateSession}>
                            <div className="row">
                                <div className="col-md-6">
                                    <AccountSelector
                                        Accounts={OBOState.billToAccounts}
                                        AccountType={'BillTo'}
                                        onAccountSelection={
                                            handleBillToSelection
                                        }
                                        selectedAccount={
                                            oboSelection!.billToAccount
                                        }
                                    />
                                </div>
                                <div className="col-md-6">
                                    <AccountSelector
                                        Accounts={OBOState.shipToAccounts}
                                        AccountType={'ShipTo'}
                                        onAccountSelection={
                                            handleShipToSelection
                                        }
                                        selectedAccount={
                                            oboSelection!.shipToAccount
                                        }
                                    />
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                {!searching ? (
                                    <button
                                        className="btn btn-primary"
                                        type="submit"
                                    >
                                        {intl.formatMessage({
                                            id: 'Order_on_behalf_of',
                                            defaultMessage:
                                                'Order on behalf of',
                                        })}{' '}
                                        {OBOState.accountNumber}
                                    </button>
                                ) : (
                                    <button
                                        disabled={true}
                                        className="btn btn-primary"
                                    >
                                        {' '}
                                        <img
                                            src={loadingGif}
                                            alt="Order on behalf Of"
                                        />
                                        {intl.formatMessage({
                                            id: 'Order_on_behalf_of',
                                            defaultMessage:
                                                'Order on behalf of',
                                        })}{' '}
                                        {OBOState.accountNumber}...
                                    </button>
                                )}
                                <button
                                    className="btn btn-default"
                                    onClick={handleCancel}
                                >
                                    {intl.formatMessage({
                                        id: 'Cancel',
                                        defaultMessage: 'Cancel',
                                    })}
                                </button>
                            </div>
                        </form>
                    </div>
                ) : (
                    <div />
                )}
            </div>
        </div>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        oboAccount: state.obo ? state.obo.data! : null,
        session: state.session ? state.session.data! : null,
    };
};

const mapDispatchToProps = {
    searchOBOAccount,
    updateLoadSession,
};

const OBOContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(AccountSearch);

export default OBOContainer;
